import { SignatureType } from './SignatureType';

export class SignatureRequestData {

  public certificate: string;
  public imprint: string;
  public documentToSign: File;
  public uuid: string;
  public signatureTypeEnum: SignatureType;
  public fileType: string;

  constructor() {

  }
}
